/* The "this chat came in via X" glyph. The chat lists (the sidebar, All chats,
   the home page's recent chats), the chat header, the read-only channel note
   and the template cards all render it, so it cannot live inside the
   interfaces screen. */

import React from "react";
import { catalogFor } from "@/shared/lib/interface-catalog";
import { channelBrandPaths } from "./icons/channels/paths";
import type { RunInterface } from "@/shared/types";

/* Tiny origin glyph for "this chat came in via X" — sidebar rows, chat lists. */
export function ViaIcon({ type, size = 14, className = "", decorative = false }: {
  type?: RunInterface | null;
  size?: number;
  className?: string;
  /** Beside the channel's visible name: hidden from screen readers, so the name isn't read twice. */
  decorative?: boolean;
}) {
  const meta = type ? catalogFor(type) : undefined;
  if (!meta) return null;
  const name = `via ${meta.name}`;
  const title = decorative ? null : <title>{name}</title>;
  const props = {
    ...(decorative ? { "aria-hidden": true } : { role: "img", "aria-label": name }),
    className: `shrink-0 text-[var(--text-secondary)] ${className}`,
    width: size,
    height: size,
    strokeWidth: 1.75,
  };
  const path = meta.brand ? channelBrandPaths[meta.brand] : undefined;
  if (path) {
    return (
      <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        {title}
        <path d={path} />
      </svg>
    );
  }
  const { Icon } = meta;
  return Icon ? <Icon {...props}>{title}</Icon> : null;
}
